import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftAutocompleteResponse } from '@/repositories/generated';

const response: GiftAutocompleteResponse[] = [
  {
    id: '1',
    name: 'モック商品券1',
  },
  {
    id: '2',
    name: 'モック商品券2',
  },
  {
    id: '3',
    name: 'モック商品券3',
  },
];

export const autocompleteGift = http.get(
  createMockEndpoint('/autocomplete/gift'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
